module.exports = __webpack_public_path__ + "img/template_2.3b369e88.jpg";